<template>
  <v-container>
    <v-row v-if="loading">
      <v-col
        cols="12"
        xl="4"
        lg="4"
        md="4"
        sm="6"
        v-for="item in 24"
        :key="item"
        no-gutters
        class="py-2"
      >
        <v-card max-height="200px">
          <v-skeleton-loader type="list-item-avatar-three-line" />
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        xl="4"
        lg="4"
        md="4"
        sm="6"
        v-for="prospect in prospectsList"
        :key="prospect.id"
        no-gutters
        class="py-2"
      >
        <Prospect
          :prospect="prospect"
          @deleteProspect="deleteProspectRequest(prospect)"
          @makeClient="makeClientRequest(prospect)"
        />
      </v-col>
      <v-col v-if="busyGettingData">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-col>
    </v-row>
    <div class="overlayCenter" v-if="!loading && prospectsList.length <= 0">
      <p class="text-center">{{ translations.advice_not_prospects }}</p>
    </div>
  </v-container>
</template>

<script>
//vuex
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
//components
import Prospect from "@/components/home/items/Prospect.vue";
import axios from "axios";
export default {
  components: {
    Prospect,
  },
  data: () => ({
    prospectsList: [],
    loading: true,
    page: 0,
    request: null,
    isMoreData: true,
    busyGettingData: false,
  }),
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  async mounted() {
    this.SET_LOADER(true);
    try {
      let CancelToken = axios.CancelToken;
      let source = CancelToken.source();
      this.request = source;
      let response = await this.getProspects({
        page: this.page,
        search: this.search ? this.search : "",
        source: this.request,
      });
      if (response) {
        this.page++;
        this.prospectsList = response.prospectus;
      } else {
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal, intente de nuevo !!",
          timeout: 4000,
        });
      }
    } catch (e) {
      console.log(e);
      this.SET_ALERT_TYPE({
        visible: true,
        type: "error",
        text: "Algo salio mal, intente de nuevo !!",
        timeout: 4000,
      });
    }
    window.addEventListener("scroll", this.handleScroll);
    this.loading = false;
    this.SET_LOADER(false);
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("user", ["search"]),
  },
  methods: {
    ...mapActions("user", ["deleteProspect", "makeClient", "getProspects"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations(["SET_LOADER"]),
    async deleteProspectRequest(prospect) {
      try {
        let response = await this.deleteProspect({ _id: prospect._id });

        if (response) {
          await this.removerProspect(prospect);
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
    async makeClientRequest(prospect) {
      try {
        let response = await this.makeClient({
          prospectId: prospect._id,
          distributorId: localStorage.getItem("distributionOrganizationId"),
        });

        if (response) {
          this.changePage();
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
    async removerProspect(prospect) {
      let index = this.prospectsList.indexOf(prospect);
      this.prospectsList.splice(index, 1);
    },
    changePage() {
      this.SET_ALERT_TYPE({
        visible: true,
        type: "success",
        text: this.translations.label_client_created,
        timeout: 1000,
      });
      this.$emit("clientAdded");
    },
    async handleScroll() {
      try {
        if (
          window.scrollY + window.innerHeight >=
          document.body.scrollHeight - 50
        ) {
          if (this.isMoreData) {
            if (this.busyGettingData) return;
            this.busyGettingData = true;
            let CancelToken = axios.CancelToken;
            let source = CancelToken.source();
            this.request = source;
            let response = await this.getProspects({
              page: this.page,
              search: this.search ? this.search : "",
              source: this.request,
            });
            if (response) {
              if (response.prospectus.length > 0) {
                this.prospectsList.push(...response.prospectus);
              } else {
                this.isMoreData = false;
              }
              this.page++;
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: this.translations.advice_error,
                timeout: 4000,
              });
            }
          }
          this.busyGettingData = false;
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
  },
  watch: {
    async search(value) {
      let text = value ? value : "";
      this.prospectsList = [];
      this.page = 0;
      this.isMoreData = true;
      this.loading = true;
      this.scrollTop();
      try {
        if (this.request != null) {
          this.request.cancel("SE CANCELO");
          let CancelToken = axios.CancelToken;
          let source = CancelToken.source();
          this.request = source;
        } else {
          let CancelToken = axios.CancelToken;
          let source = CancelToken.source();
          this.request = source;
        }
        let response = await this.getProspects({
          page: this.page,
          search: text,
          source: this.request,
        });
        if (response && response.prospectus) {
          if (response.prospectus.length > 0) {
            this.prospectsList = response.prospectus;
          } else {
            this.isMoreData = false;
          }
          this.page++;
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.overlayCenter {
  display: fixed;
  flex: 100%;
  top: 50%;
  left: 20%;
  right: 20%;
  bottom: 50%;
  z-index: 1;
  position: absolute;
}
</style>
